
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Actions from "../../Components/Ui/tables/Actions";
import { Button } from "antd";
import { ImageBaseURL } from "../../api/config";


const useTableColumns :any = () => {
  const [t] = useTranslation();
    return useMemo(
    () => [
 
      {
        name: t("id"),
        sortable: true,
        center: true,
        selector: (row: any) => row.id, 
      }, 
      {
        name: t("name"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.name
      },
      {
        name: t("email"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.email
      },
      {
        name: t("phone"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.phone
      },

      {
        name: t("message"),
        width:"200",
        sortable: false,
        center: "true",
        cell: (row:any) => <div className="single-line-div">{row?.message} </div> 
      },
      {
        name: t("attachment"),
        sortable: false,
        center: "true",
        cell: (row:any) =>  {
          let src =  ImageBaseURL+row?.attachment;
          const handleClick = () => {
            if (row?.attachment) {
                window.open(src, '_blank');
            }
        };
        if(!row?.attachment){
          return <Button >no attachment</Button>
        }
          return    <Button onClick={handleClick}>attachment</Button>
        }
      },
      {
        name: "#",
        sortable: false,
        center: true,
        cell: (row:any) => (
          <Actions
            objectToEdit={row}
            showEdit={false}
            showView={false}
            showDelete={false}
          >  
          </Actions>
        ),
      },

    ],
    [t]
  );
};

export default useTableColumns;

